import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-debit-voucher-bill',
  templateUrl: './debit-voucher-bill.component.html',
  styleUrl: './debit-voucher-bill.component.scss'
})
export class DebitVoucherBillComponent {

  rep_name: any
  d_voucher_no: any
  d_voucher_date: any
  narration: any
  debitmainexpenses: any[] = [];
  debitsubexpenses: any[] = [];
  debitexpenses: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<DebitVoucherBillComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.rep_name = this.data['repname'];
    this.d_voucher_no = this.data['dvoucherno'];
    this.narration = this.data['narration'];
    this.d_voucher_date = this.data['dvoucherdate'];
    this.debitmainexpenses = this.data['debitmainexpenses'];
    this.debitsubexpenses = this.data['debitsubexpenses'];
    this.getData();
  }

  // getData() {
  //   this.debitexpenses = [
  //     ...this.debitmainexpenses.map(item => ({
  //       mainexpname: item.mainexpname,
  //       subexpname: null,
  //       expamt: item.expamt
  //     })),
  //     ...this.debitsubexpenses.map(item => ({
  //       mainexpname: item.mainexpname,
  //       subexpname: item.subexpname,
  //       expamt: item.expamt
  //     }))
  //   ];

  // }

  getData() {
    // Filter main expenses that do NOT have corresponding sub expenses
    const mainExpensesWithoutSub = this.debitmainexpenses.filter(main =>
      !this.debitsubexpenses.some(sub => sub.mainexpid === main.mainexpid)
    );

    // Prepare final list
    this.debitexpenses = [
      ...mainExpensesWithoutSub.map(item => ({
        mainexpname: item.mainexpname,
        subexpname: null,
        expamt: item.expamt
      })),
      ...this.debitsubexpenses.map(item => ({
        mainexpname: item.mainexpname,
        subexpname: item.subexpname,
        expamt: item.expamt
      }))
    ];
  }

  getTotalExpenseAmt(): number {
    return this.debitexpenses.reduce((sum, expense) => sum + (parseFloat(expense.expamt) || 0), 0);
  }

  getTotalInMarathiWords(): string {
    const total = this.getTotalExpenseAmt();
    return this.convertNumberToMarathiWords(total);
  }

  convertNumberToMarathiWords(amount: number): string {
    const marathiNumbers: string[] = [
      'शून्य', 'एक', 'दोन', 'तीन', 'चार', 'पाच', 'सहा', 'सात', 'आठ', 'नऊ',
      'दहा', 'अकरा', 'बारा', 'तेरा', 'चौदा', 'पंधरा', 'सोळा', 'सतरा', 'अठरा', 'एकोणीस',
      'वीस', 'एकवीस', 'बावीस', 'तेवीस', 'चोवीस', 'पंचवीस', 'सव्वीस', 'सत्तावीस', 'अठावीस', 'एकोणतीस',
      'तीस', 'एकतीस', 'बत्तीस', 'तेहतीस', 'चौतीस', 'पस्तीस', 'छत्तीस', 'सदतीस', 'अडतीस', 'एकोणचाळीस',
      'चाळीस', 'एकचाळीस', 'बावन्न', 'त्रेचाळीस', 'चव्वेचाळीस', 'पंचेचाळीस', 'सेहेचाळीस', 'सत्तेचाळीस', 'अठ्ठेचाळीस', 'एकोणपन्नास',
      'पन्नास', 'एकावन्न', 'बावन्न', 'त्रेपन्न', 'चव्वेचपन्न', 'पंचावन्न', 'छप्पन्न', 'सत्तावन्न', 'अठ्ठावन्न', 'एकोणसाठ',
      'साठ', 'एकसष्ठ', 'बासष्ठ', 'त्रेसष्ठ', 'चव्वेसष्ठ', 'पंचसष्ठ', 'सहासष्ठ', 'सदुसष्ठ', 'अडुसष्ठ', 'एकोणसत्तर',
      'सत्तर', 'एकाहत्तर', 'बाहत्तर', 'त्र्याहत्तर', 'चौर्‍याहत्तर', 'पंच्याहत्तर', 'शहात्तर', 'सत्त्याहत्तर', 'अठ्ठ्याहत्तर', 'एकोणऐंशी',
      'ऐंशी', 'एक्याऐंशी', 'ब्याऐंशी', 'त्र्याऐंशी', 'चौऱ्याऐंशी', 'पंच्याऐंशी', 'शहाऐंशी', 'सत्त्याऐंशी', 'अठ्ठ्याऐंशी', 'एकोणनव्वद',
      'नव्वद', 'एकाण्णव', 'बाण्णव', 'त्रेपण्णव', 'चौऱ्याण्णव', 'पंच्याण्णव', 'शहाण्णव', 'सत्त्याण्णव', 'अठ्ठ्याण्णव', 'नव्व्याण्णव'
    ];

    const parts: string[] = [];

    const crore = Math.floor(amount / 10000000);
    if (crore) {
      parts.push(marathiNumbers[crore] + ' कोटी');
      amount %= 10000000;
    }

    const lakh = Math.floor(amount / 100000);
    if (lakh) {
      parts.push(marathiNumbers[lakh] + ' लाख');
      amount %= 100000;
    }

    const thousand = Math.floor(amount / 1000);
    if (thousand) {
      parts.push(marathiNumbers[thousand] + ' हजार');
      amount %= 1000;
    }

    const hundred = Math.floor(amount / 100);
    if (hundred) {
      parts.push(marathiNumbers[hundred] + 'शे');
      amount %= 100;
    }

    if (amount) {
      parts.push(marathiNumbers[amount]);
    }

    return parts.join(' ') + ' रुपये मात्र';
  }

  print() {
    const originalTitle = document.title; // Store original title
    document.title = '';     // Set custom print title

    // Create a style tag for print-specific styles
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 20mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;

    document.head.appendChild(style); // Add style to the document

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();

      document.title = ''; // Restore original title after printing

      // document.head.removeChild(style); // Remove the style after printing
    }, 500); // Delay ensures styles apply before printing
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

}